import { jsx as _jsx } from "react/jsx-runtime";
import usePlugins from "../usePlugins";
const ElementRenderer = (props) => {
    const { attributes, children } = props;
    const plugins = usePlugins();
    const plugin = plugins
        .map((plugin) => plugin.element)
        .find(({ match }) => match(props));
    if (plugin) {
        const Component = plugin.component;
        return _jsx(Component, Object.assign({}, props));
    }
    return (_jsx("p", Object.assign({ style: { margin: 0, padding: 0 } }, attributes, { children: children })));
};
export default ElementRenderer;
